import { Suspense } from 'react';

import { authApi, useSelectLoginState } from '@treneo/features/auth';
import { useSelectUserTheme } from '@treneo/features/user';
import { SignalRConnectionContextProvider } from '@treneo/infrastructure/realtime';
import { useAuthInitializer, useTokenRefresh } from '@treneo/processes/auth';
import { Themes } from '@treneo/shared/constants';
import { Colors, getThemeDark, getThemeLight } from '@treneo/shared/themes';
import { CssBaseline, ThemeProvider, Toaster } from '@treneo/shared/ui';

import { Router } from './router/router';

export const App = () => {
  useTokenRefresh();
  useAuthInitializer();

  const applicationTheme = useSelectUserTheme();
  const loginState = useSelectLoginState();

  const currentTheme =
    applicationTheme && applicationTheme === Themes.dark ? getThemeDark() : getThemeLight();

  const handleRefreshToken = async () => {
    await authApi.refreshToken();
  };

  return (
    <ThemeProvider theme={currentTheme}>
      <CssBaseline />
      <Suspense fallback='Loading'>
        <SignalRConnectionContextProvider
          loginState={loginState}
          onRefreshToken={handleRefreshToken}
        >
          <Router />
          <Toaster
            position='top-right'
            toastOptions={{
              style: {
                background: Colors.green,
                color: Colors.white
              }
            }}
          />
        </SignalRConnectionContextProvider>
      </Suspense>
    </ThemeProvider>
  );
};
